import { render, staticRenderFns } from "./CurationHistoryModal.vue?vue&type=template&id=34bc64d6&scoped=true"
import script from "./CurationHistoryModal.vue?vue&type=script&lang=js"
export * from "./CurationHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc64d6",
  null
  
)

export default component.exports